import { z } from 'zod';
import { DISPOSAL_PURPOSE_SCHEMA } from '@schuettflix/interfaces';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';
import { AbstractAdditionalProperties } from './abstract-additional-properties.ts';

export const AutomaticMaterialPropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['AUTOMATIC_MATERIAL_V1']),
    sellerProductId: z.string().optional(),
    productDefinitionId: z.string().optional(),
});
export type AutomaticMaterialPropertiesV1 = z.infer<typeof AutomaticMaterialPropertiesSchemaV1>;

export const AutomaticMaterialWastePropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['AUTOMATIC_WASTE_MATERIAL_V1']),
    disposalPurpose: DISPOSAL_PURPOSE_SCHEMA,
    sellerProductId: z.string().optional(),
    productDefinitionId: z.string().optional(),
});

export type AutomaticMaterialWastePropertiesV1 = z.infer<typeof AutomaticMaterialWastePropertiesSchemaV1>;
